
<div class="row">
    <div class="col">
        <div class="text-center" *ngIf="spinnerGraphicRejected">
            <span>
                <p-progressSpinner></p-progressSpinner>
            </span>
            <br />
            <span class="text-center">Cargando...</span>
        </div>
    </div>
</div>

<div class="row" [ngClass]="{
    'd-none'  : spinnerGraphicRejected
}">
    <div class="col">
        <div id="chart3">
    </div>
</div>

